import { UzSelect } from '@utazzo/ui';
import React from 'react';

const MONTHS = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
];

/**
 * Reporting period selector: a single MONTH + YEAR (default current month,
 * wired by the caller). Carry-forward is a month-boundary concept, so the
 * report period is always a whole month rather than a rolling date range -
 * which keeps every metric stable and reproducible. Future months in the
 * current year are disabled (no data yet).
 */
export const MonthYearFilter = ({
  month,
  year,
  onChange,
}: {
  /** 1-12 */
  month: number;
  year: number;
  onChange: (month: number, year: number) => void;
}): React.JSX.Element => {
  const now = new Date();
  const currentYear = now.getFullYear();
  const currentMonth = now.getMonth() + 1;
  const years: number[] = [];
  for (let y = currentYear; y >= currentYear - 4; y--) years.push(y);

  return (
    <div className="flex items-center gap-2">
      <UzSelect
        value={String(month)}
        onValueChange={(v) => onChange(Number(v), year)}
        triggerClassName="h-9 w-30"
        options={MONTHS.map((label, i) => ({
          value: String(i + 1),
          label,
          disabled: year === currentYear && i + 1 > currentMonth,
        }))}
      />
      <UzSelect
        value={String(year)}
        onValueChange={(v) => onChange(month, Number(v))}
        triggerClassName="h-9 w-20"
        options={years.map((y) => ({ value: String(y), label: String(y) }))}
      />
    </div>
  );
};
